// src/encounter/lib/order-types.ts
// Reconcile useRole's OrderType (6 — includes 'vaccination') with the DS AssessmentPlanCanvas
// OrderType. As of DS 1.21.0 the canvas grows a 'vaccination' OrderType (PROD-1227), so the doctor
// attaches a vaccine request per-Dx via the "+ Vaccine" rail like any other order — the consuming
// app opens its own VaccineAddDialog → VaccinationAdminEditor on onAddOrder(dxId, 'vaccination').
import type { OrderType as DsOrderType } from '@scripsteam/scrips-signal-ds';
import type { OrderType as AppOrderType } from '@/auth/use-role';

// Canonical DS canvas order, intersection of app ∩ DS — in Flutter's A&P tab order
// (assessment_plan_search_list_widget.dart:110-193, radiology→imaging): labs · meds · vaccination ·
// radiology · procedures. `toCanvasOrderTypes` filters an allowed set while preserving THIS order,
// so reordering here reorders the panel tabs + canvas order types.
//
// Referral is shown only behind the `referrals` encounter flag (PROD-1395: the Patient backend now saves referrals; it was
// hidden under PROD-1452 while CreateAssessment ignored them). Flag OFF keeps it out, exactly as before.
// Education (Flutter's 7th tab) is a separate net-new slice (PROD-1454) — added when its search/persist contract is confirmed.
const CANVAS_ORDER_TYPES: DsOrderType[] = ['lab', 'medication', 'vaccination', 'imaging', 'procedure'];

export function toCanvasOrderTypes(allowed: AppOrderType[], options: { referrals?: boolean } = {}): DsOrderType[] {
  const set = new Set<string>(allowed);
  const types = CANVAS_ORDER_TYPES.filter((t) => set.has(t));
  // 'referral' goes after 'procedure', and only when the flag is on AND the role may order it.
  if (options.referrals && set.has('referral')) types.push('referral');
  return types;
}
